/**
 * Generated by orval v8.9.1 🍺
 * Do not edit manually.
 * Praetoid Dashboard API
 * OpenAPI spec version: 1.0
 */
import * as zod from 'zod';

export const ApiSummary = zod
	.object({
		avg_duration_ms: zod.number().describe('Average duration in ms'),
		p95_duration_ms: zod.number().describe('95th percentile duration in ms'),
		total_errors: zod.number().describe('Total errors in range'),
		total_requests: zod.number().describe('Total requests in range')
	})
	.describe('API request summary');

export type ApiSummary = zod.input<typeof ApiSummary>;
export type ApiSummaryOutput = zod.output<typeof ApiSummary>;
